module.exports = __webpack_public_path__ + "img/icon-check.3c43a486.svg";